import { render } from "./productMenuMobile.vue?vue&type=template&id=043d370b&scoped=true"
import script from "./productMenuMobile.vue?vue&type=script&lang=js"
export * from "./productMenuMobile.vue?vue&type=script&lang=js"

import "./productMenuMobile.vue?vue&type=style&index=0&id=043d370b&scoped=true&lang=css"

import exportComponent from "C:\\Users\\krist\\Documents\\pbetoon\\pBetoon-main\\ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-043d370b"]])

export default __exports__